<template>
  <v-dialog v-model="dialogModel" persistent max-width="500">
    <v-card>
      <v-card-title>
        <h3>Parked Sales</h3>
      </v-card-title>
      <v-card-text>
        <v-layout
          row
          v-for="(item, index) in items"
          :key="`parked-sale-${index}`"
        >
          <v-flex xs12 sm3 class="grey--text">Note: {{ item.note }}</v-flex>
          <!-- <v-flex xs12 sm3>{{ item.saleItems[0].barcode }}</v-flex>
          <v-flex xs12 sm3>{{ item.saleItems[0].productName }}</v-flex>
          <v-flex xs12 sm3>{{ item.saleItems[0].factorUnitName }}</v-flex> -->
          <v-flex xs12 sm3>
            <v-btn color="primary" @click="retrieve(item, index)">
              <v-icon>reply</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row v-show="items.length === 0">
          <v-flex>There is no park wholeSaleHeader.</v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="dialogModel = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog"],
  data: () => ({
    items: [],
  }),
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set() {
        this.$emit("update:dialog");
      },
    },
  },
  watch: {
    dialogModel(v) {
      if (v) {
        const parkItems = JSON.parse(localStorage.getItem("parkItems"));
        if (parkItems) this.items = parkItems;
      }
    },
  },
  methods: {
    retrieve(item, index) {
      this.dialogModel = false;
      this.updateParked(index);
      this.$emit("retrieved", item);
    },
    updateParked(index) {
      this.$delete(this.items, index);
      localStorage.setItem("parkItems", JSON.stringify(this.items));
    },
  },
};
</script>

<style></style>
